import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MetricScoresService, MetricScoreGroup, MetricScore, MetricScorePut } from 'src/app/services/metric-scores.service';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { RankingsService, Ranking } from 'src/app/services/rankings.service';
import { takeUntil } from 'rxjs/operators';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-scoring',
  templateUrl: './scoring.component.html',
  styleUrls: ['./scoring.component.scss']
})
export class ScoringComponent implements OnInit {

  rankingId: number;
  rankingName: string;
  rankingDate: string;
  rankingStatus: string;
  rankingEffectiveDate: Date;
  metricScores: MetricScoreGroup[];
  saveScoresEvent: Subject<void> = new Subject<void>();
  metricScoresOutgoing: MetricScore[] = [];
  metricScoresOutgoingLength: number;
  outsideLimits: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public rankingsService: RankingsService,
    private metricScoresService: MetricScoresService,
    private toastrService: ToastrService,
    private modalConfig: NgbModalConfig,
    private modalService: NgbModal) { }

  unsubscribe: Subject<any> = new Subject();

  ngOnInit() {

    this.rankingId = parseInt(this.route.snapshot.params.rankingId);

    this.rankingsService.getRanking(this.rankingId);

    this.rankingsService.currentRanking
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(rank => {
        if (rank) {
          this.rankingName = rank.rankingName;
          this.rankingDate = new Date(rank.rankingDate).toLocaleDateString("en-US");
          this.rankingStatus = rank.rankingStatusName;
          this.rankingEffectiveDate = rank.effectiveDate;
      }
    });

    this.metricScoresService.generateScores(this.rankingId);

    this.metricScoresService.currentMetricScores
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(metricScores => {
      if (metricScores && metricScores.length) {
        this.metricScores = metricScores;
        this.metricScoresOutgoingLength = metricScores.length * metricScores[0].metricScoresList.length;
      }
    });

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  triggerSaveScores() {
    this.saveScoresEvent.next();
  }

  generateMetricScoresUpdate($event, content) {
    if ($event.score < 0 || $event.score > 100) {
      this.outsideLimits = true;
    }
    this.metricScoresOutgoing.push(this.removeExtraProperties($event));
    if (this.metricScoresOutgoing.length === this.metricScoresOutgoingLength) {
      if (this.outsideLimits) {
        this.toastrService.error('Scoring values must be between 0 and 100', 'Error:');
      } else {
        this.metricScoresService.putScores(this.metricScoresOutgoing);
        this.modalService.open(content);
      }
      this.metricScoresOutgoing = [];
      this.outsideLimits = false;
    }
  }

  removeExtraProperties(metricScore: MetricScore): MetricScore {
    let tempMetricScore: MetricScorePut = {} as MetricScorePut;
    tempMetricScore.metricScoreId = metricScore.metricScoreId;
    tempMetricScore.rankingId = this.rankingId;
    tempMetricScore.score = metricScore.score;
    return tempMetricScore;
  }

  finalizeRanking(action: string) {
    this.rankingsService.submitRanking(this.rankingId, "Finalize");
  }

  finalizeModal(action, modal) {
    if (action == "Finalize" ) {
      this.modalService.open(modal);
    }
  }
}
